import { useEffect, useState } from "react";
import { ABOUT_NAV } from "../../constants/about";

const STICKY_TOP = "calc(4.5rem + 3px)";

function AboutRail() {
  const [active, setActive] = useState(ABOUT_NAV[0].id);

  useEffect(() => {
    const nodes = ABOUT_NAV.map((item) => document.getElementById(item.id)).filter(Boolean);
    if (!nodes.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        const id = visible[0]?.target.id;
        if (id) setActive(id);
      },
      { rootMargin: "-28% 0px -55% 0px", threshold: [0, 0.15, 0.4] }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  const jump = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", `#${id}`);
  };

  return (
    <nav
      className="sticky z-40 border-b border-navy/10 bg-white/92 backdrop-blur-md"
      style={{ top: STICKY_TOP }}
      aria-label="On this page"
    >
      <div className="mx-auto flex max-w-8xl items-center gap-2 overflow-x-auto px-4 py-2.5 [-ms-overflow-style:none] [scrollbar-width:none] sm:px-6 lg:px-8 [&::-webkit-scrollbar]:hidden">
        <p className="hidden shrink-0 pr-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-navy/35 lg:block">
          On this page
        </p>
        <ul className="flex min-w-0 items-center gap-1.5">
          {ABOUT_NAV.map((item) => {
            const current = item.id === active;
            return (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => jump(item.id)}
                  className={`inline-flex min-h-10 cursor-pointer items-center whitespace-nowrap rounded-full px-3.5 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royal ${
                    current
                      ? "bg-navy text-white"
                      : "text-navy/60 hover:bg-navy/[0.05] hover:text-navy"
                  }`}
                  aria-current={current ? "location" : undefined}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}

export default AboutRail;
